import { translate } from 'react-translate'

import DeviceType from './device-type'

export default translate('DeviceType')(DeviceType)
